import(/* webpackMode: "eager" */ "/app/src/app/network-dao/vote/[path]/page.tsx")